export const seedPaymentPlans = [
  {
    id: "basic-monthly",
    title: "Basic",
    priceText: "₺299/ay",
    period: "monthly",
    features: ["1 ilan", "Temel görünürlük", "Rezervasyon bildirimleri"],
  },
  {
    id: "pro-monthly",
    title: "Pro",
    priceText: "₺699/ay",
    period: "monthly",
    features: ["Sınırsız ilan", "Öne çıkarma", "Rezervasyon yönetimi"],
  },
  {
    id: "pro-yearly",
    title: "Pro Yıllık",
    priceText: "₺6.990/yıl",
    period: "yearly",
    features: ["Sınırsız ilan", "Öne çıkarma", "Öncelikli destek"],
  },
];

export const seedAppConfig = [
  {
    id: "mobile",
    featuredProvinceOrder: [
      "trabzon",
      "rize",
      "artvin",
      "samsun",
      "ordu",
      "giresun",
      "sinop",
      "amasya",
      "karabuk",
      "bolu",
      "kastamonu",
      "bartin",
    ],
  },
];

export const seedTravelFlights = [
  {
    id: "f1",
    airline: "AJet",
    flightCode: "VF 5311",
    cabin: "Ekonomi",
    departureTime: "20:05",
    departureAirport: "ADB",
    arrivalTime: "09:00",
    arrivalAirport: "OGU",
    arrivalNextDay: true,
    duration: "12sa 55dk",
    stops: "1 Aktarmalı (ESB)",
    price: 3849.99,
  },
  {
    id: "f2",
    airline: "Pegasus",
    flightCode: "PC 2184",
    cabin: "Ekonomi",
    departureTime: "07:40",
    departureAirport: "ADB",
    arrivalTime: "11:15",
    arrivalAirport: "OGU",
    duration: "3sa 35dk",
    stops: "Direkt",
    price: 4299.0,
  },
  {
    id: "f3",
    airline: "Türk Hava Yolları",
    flightCode: "TK 2310",
    cabin: "Ekonomi",
    departureTime: "14:20",
    departureAirport: "ADB",
    arrivalTime: "18:05",
    arrivalAirport: "OGU",
    duration: "3sa 45dk",
    stops: "Direkt",
    price: 5120.5,
  },
];

export const seedTravelBuses = [
  {
    id: "b1",
    company: "Lüks Karadeniz",
    departureTime: "12:00",
    departureStation: "İzmir Otogarı",
    arrivalTime: "08:30",
    arrivalStation: "Trabzon Otogarı",
    duration: "20 sa 30 dk",
    seatLayout: "2+1",
    price: 2250,
    cancellable: true,
  },
  {
    id: "b2",
    company: "Kanberoğlu Turizm",
    departureTime: "13:00",
    departureStation: "İzmir Otogarı",
    arrivalTime: "09:00",
    arrivalStation: "Trabzon Otogarı",
    duration: "20 sa 00 dk",
    seatLayout: "2+1",
    price: 2200,
    cancellable: true,
  },
  {
    id: "b3",
    company: "Ali Osman Ulusoy",
    departureTime: "13:30",
    departureStation: "İzmir Otogarı",
    arrivalTime: "10:00",
    arrivalStation: "Trabzon Otogarı",
    duration: "20 sa 30 dk",
    seatLayout: "2+1",
    price: 2250,
    cancellable: true,
  },
];

export const seedTravelHotels = [
  {
    id: "h1",
    name: "La Quinta By Wyndham Giresun",
    location: "Giresun Şehir Merkezi, Giresun",
    rating: 8.2,
    ratingLabel: "Çok İyi",
    reviewCount: 40,
    mealPlan: "Oda Kahvaltı",
    badges: ["1 Çocuk İçin Ücretsiz", "Ücretsiz İptal", "Otele Ödeme imkanı"],
    campaign: "Maximum ile sepette %5 ek indirim!",
    price: 7395,
    discountedPrice: 7025,
    imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
  },
  {
    id: "h2",
    name: "Radisson Blu Hotel, Ordu",
    location: "Altınordu, Ordu",
    rating: 8.8,
    ratingLabel: "Mükemmel",
    reviewCount: 126,
    mealPlan: "Yarım Pansiyon",
    badges: ["Ücretsiz İptal", "Deniz Manzarası"],
    price: 5890,
    discountedPrice: 5490,
    imageUrl: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80",
  },
  {
    id: "h3",
    name: "Park Dedeman Trabzon",
    location: "Ortahisar, Trabzon",
    rating: 8.5,
    ratingLabel: "Çok İyi",
    reviewCount: 89,
    mealPlan: "Oda Kahvaltı",
    badges: ["Ücretsiz İptal"],
    price: 6200,
    imageUrl: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80",
  },
];

export const seedTravelTours = [
  {
    id: "t1",
    title: "Celestyal Discovery ile Yunan Adaları & Atina Kış Programı 3 Gece 21 Kasım",
    route: "Aydın, Kuşadası, Patmos, Santorini, Atina, Mikonos",
    dateRange: "21 Kas'26 - 24 Kas'26",
    duration: "3 Gece, 4 Gün",
    priceEur: 264,
    priceTry: 14231,
    promotion: "7.500 TL'ye Varan MaxiPuan Kazanma Fırsatı",
    imageUrl: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&q=80",
  },
  {
    id: "t2",
    title: "Karadeniz Yaylaları ve Fırtına Vadisi Macera Turu",
    route: "Trabzon, Uzungöl, Ayder, Fırtına Vadisi",
    dateRange: "10 Tem'26 - 13 Tem'26",
    duration: "3 Gece, 4 Gün",
    priceEur: 0,
    priceTry: 8990,
    imageUrl: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
  },
  {
    id: "t3",
    title: "Batum & Batum Gece Turu Vizesiz Program",
    route: "Rize, Hopa, Batum",
    dateRange: "5 Ağu'26 - 6 Ağu'26",
    duration: "1 Gece, 2 Gün",
    priceEur: 0,
    priceTry: 4250,
    promotion: "Vizesiz turlar kampanyası",
    imageUrl: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&q=80",
  },
];

export const seedTravelCars = [
  {
    id: "c1",
    name: "Fiat Egea",
    category: "Ekonomi",
    supplier: "Avis",
    transmission: "Manuel",
    fuel: "Benzin",
    seats: 5,
    bags: 2,
    features: ["Klima", "Bluetooth"],
    pricePerDay: 890,
    totalPrice: 2670,
    freeCancellation: true,
    imageUrl: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&q=80",
  },
  {
    id: "c2",
    name: "Renault Clio",
    category: "Ekonomi",
    supplier: "Garenta",
    transmission: "Otomatik",
    fuel: "Benzin",
    seats: 5,
    bags: 2,
    features: ["Klima", "USB"],
    pricePerDay: 1050,
    totalPrice: 3150,
    freeCancellation: true,
    imageUrl: "https://images.unsplash.com/photo-1494976388531-d1058498cdd5?w=800&q=80",
  },
  {
    id: "c3",
    name: "Dacia Duster",
    category: "SUV",
    supplier: "Enterprise",
    transmission: "Manuel",
    fuel: "Dizel",
    seats: 5,
    bags: 4,
    features: ["4x4", "Klima", "Navigasyon"],
    pricePerDay: 1450,
    totalPrice: 4350,
    freeCancellation: false,
    imageUrl: "https://images.unsplash.com/photo-1519641471654-76ce5427bbae?w=800&q=80",
  },
  {
    id: "c4",
    name: "Volkswagen Passat",
    category: "Orta Sınıf",
    supplier: "Budget",
    transmission: "Otomatik",
    fuel: "Dizel",
    seats: 5,
    bags: 3,
    features: ["Klima", "Cruise Control", "Bluetooth"],
    pricePerDay: 1680,
    totalPrice: 5040,
    freeCancellation: true,
    imageUrl: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800&q=80",
  },
];
